var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"v-component",attrs:{"device":_vm.source},scopedSlots:_vm._u([_vm._l((_vm.$slots),function(index,name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }